import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Descriptionstyled = styled.div`
  position: relative;
  .gatsby-image-wrapper {
    max-width: 150px !important;
    height: auto !important;
    margin: 0 auto !important;
  }
`

export const LogoDescription = ({ children }) => (
  <Descriptionstyled>{children}</Descriptionstyled>
)
